import React, { StatelessComponent } from 'react';
import Helmet from 'react-helmet';

import Settings from '@interfaces/settings';

export interface StateProps {
    data: Settings;
}

const AppMeta: StatelessComponent<StateProps> = ({ data }) => {
    return (
        <Helmet>
            <title>{data.title}</title>
            <meta name="description" content={data.seoDescription} />
            <meta name="keywords" content={data.metaKeywords} />
        </Helmet>
    );
};

export default AppMeta;
